import baseReport from '../baseReport';
import _ from 'lodash';

const alunosContaGoogleReport = async ({ date, time, filtros, data, professores }) => {
const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Conta Google dos Alunos' });
const dataFormated = []
const observacao = []

const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    // {
    //   fontSize: 12,
    //   text: (filtros.identificadorperfil == 2) ? [ { text:  'Professor/Educador:   ', bold: true }, professores[0].nmfuncion ] : [],
    // },
    {
      fontSize: 12,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo
          ],
        },
      ],
    },
    {
      fontSize: 12,
      columns: [
        {
          text: [
            {text: 'Professor(a)/Educador(a): ', bold: true},
            professores[0].nmfuncion

          ],
        },
      ],

    }
  ];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhum aluno encontrado.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

    const turma_array= []
     for(const i in data)
     {
        turma_array[i] = [{cdturma: data[i].cdturma}]
     }

    const turma_array2 = turma_array.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))

      for (const i in turma_array2)
      {
            dataFormated.push([
              {text: turma_array2[i][0].cdturma, bold: true, margin: [0,20,0,10]},
              {
                layout: {fillColor: '#CCCCCC'},
                alignment: 'center',
                table: {
                  headerRows: 1,
                  widths: [ '50%', '50%' ],

                  body: [
                          [   { text: 'Aluno', style: 'tableHeader', fontSize: 12 },
                              { text: 'Conta Google', style: 'tableHeader' , fontSize: 12  },
                        ]
                  ]
                }
              },
            ]);
            let cdturma = turma_array2[i][0].cdturma
            let turma =  data.filter(f => f.cdturma === cdturma)
            const isFim = turma.length -1
            turma = _.orderBy(turma, 'nmaluno')

                    for (const j in turma)
                    {
                          dataFormated.push([
                            {

                              alignment: 'left',
                              table: {
                                widths: [ '50%', '50%' ],

                                body: [
                                 [ turma[j].nmaluno, turma[j].edemailalu ],
                                ]
                              },
                              pageBreak: j == isFim && i != turma_array2.length - 1 ? 'after' : '',
                            },
                          ]);

                    }
      }

  return {
    ...headerFooter,
    content: [
        ...filtrosFormated,
        ...dataFormated,
        ...observacao,
    ],

    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
        alignment: 'center',
      },
    },
  };
};

export default alunosContaGoogleReport;
